import { render } from "./ClientApprovalsPanel.vue?vue&type=template&id=74839893&scoped=true"
import script from "./ClientApprovalsPanel.vue?vue&type=script&lang=js"
export * from "./ClientApprovalsPanel.vue?vue&type=script&lang=js"

import "./ClientApprovalsPanel.vue?vue&type=style&index=0&id=74839893&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74839893"]])

export default __exports__